import React, { Component } from 'react';
import { Table, Header } from 'semantic-ui-react';

export default class AffixInfo extends Component {
    render() {
        const {modifiers, name, position} = this.props;

        if(!modifiers || modifiers.length === 0 ) {
            return null;
        }

        const modifierRows = modifiers.map(m =>
            <Table.Row key={m.Type.Id}>
                <Table.Cell>{m.Type.Name.English}</Table.Cell>
                <Table.Cell textAlign="right">{`${m.Value * 100}%`}</Table.Cell>
            </Table.Row>
        );

        return (
            <div>
                <Header as='h3' textAlign='center'>
                    <Header.Content>
                        {name.English}
                    </Header.Content>
                    <Header.Subheader>
                        {position}
                    </Header.Subheader>
                </Header>
                <Table compact celled>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>Stat</Table.HeaderCell>
                            <Table.HeaderCell>Budget</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {modifierRows}
                    </Table.Body>
                </Table>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/items/detail/summary-card/affixes/AffixInfo.jsx